import { CombinedError } from 'urql';

import { SortAndFilterItem } from '@/components/FilterManager/types';
import { UserFragment } from '@/graphql/fragments/generated/User';
import useAsyncListActions from '@/hooks/useList/useAsyncListActions';

import { UserCollectionFragment } from '../../modules/group/views/GroupManager/graphql/fragments/generated/UserCollection';

export enum Tabs {
  Learners = 'LEARNERS',
  Groups = 'GROUPS',
}

export interface LearnerAndGroupDialogProps {
  onClose: () => void;
  onAddLearnerAndGroup: (
    learnerIds: string[],
    userGroupIds: string[],
    importedUserGroupIds?: string[],
    removedUserIds?: string[],
  ) => void;
  title?: string;
  description?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  searchPlaceholder?: string;
  selectedLearnerIds: string[];
  selectedUserGroupIds: string[];
  disabled?: boolean;
  canImport?: boolean;
  hideSecondaryAction?: boolean;
  hideGroupsTab?: boolean;
  hideUsersTab?: boolean;
  isInGroupCheckId?: string;
  importedUserGroupIds?: string[];
  removedUserIds?: string[];
}

export type UseAsyncListSelectAllManagerReturnType<T> = {
  isFetching: boolean;
  data: T[];
  fetchMore: (() => void) | undefined;
  error?: CombinedError;
  selectedCount: number;
  totalCount?: number;
  asyncList: ReturnType<typeof useAsyncListActions>;
};

export type DialogDataConfig = {
  isFetching: boolean;
  data: LearnerAndGroups[];
  fetchMore: (() => void) | undefined;
  error?: CombinedError;
  selectedCount: number;
  asyncList: ReturnType<typeof useAsyncListActions>;
  sortAndFilterItems: SortAndFilterItem[];
};

export type LearnerAndGroups = UserFragment | UserCollectionFragment;
